import { render } from "./PersonalAccount.vue?vue&type=template&id=4c56f189&scoped=true"
import script from "./PersonalAccount.vue?vue&type=script&lang=js"
export * from "./PersonalAccount.vue?vue&type=script&lang=js"

import "./PersonalAccount.vue?vue&type=style&index=0&id=4c56f189&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c56f189"]])

export default __exports__